import { Box, IconButton } from "@mui/material";
import { styled } from "@mui/system";

export const PeriodStartActionButton = styled(IconButton)({
  width: 40,
  height: 40,
  padding: 10,
  flexShrink: 0,
  "& .MuiSvgIcon-root": { fontSize: 20 },
});

// Keep full click targets while centering them against the 32px date fields.
export const PeriodStartActions = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 4,
  marginTop: -4,
  marginBottom: -4,
});
